module.exports = __webpack_public_path__ + "static/media/productutorial.10207f2e.jpg";